import { distinctValues } from "ai-management/token-usage/usageSummary";
export const GROUPINGS = {
  feature: {
    label: "token_usage.groupings.feature.label",
    detail: "token_usage.groupings.feature.detail",
    columns: [{ dimension: "feature_id", title: "token_usage.columns.feature" }],
    list: { dimension: "model", title: "token_usage.list_titles.models_used" }
  },
  provider: {
    label: "token_usage.groupings.provider.label",
    detail: "token_usage.groupings.provider.detail",
    columns: [{ dimension: "provider", title: "token_usage.columns.provider" }],
    list: { dimension: "model", title: "token_usage.list_titles.models" }
  },
  model: {
    label: "token_usage.groupings.model.label",
    detail: "token_usage.groupings.model.detail",
    columns: [{ dimension: "model", title: "token_usage.columns.model" }],
    list: { dimension: "feature_id", title: "token_usage.list_titles.used_by_features" }
  },
  feature_model: {
    label: "token_usage.groupings.feature_model.label",
    detail: "token_usage.groupings.feature_model.detail",
    columns: [
      { dimension: "feature_id", title: "token_usage.columns.feature" },
      { dimension: "model", title: "token_usage.columns.model" }
    ]
  }
};
const keyOf = (group, columns) => columns.map(({ dimension }) => group[dimension]).join("|");
export const groupOf = (group, columns) => Object.fromEntries(columns.map(({ dimension }) => [dimension, group[dimension]]));
export const groupByKey = (rows, columns) => {
  const rowsByKey = /* @__PURE__ */ new Map();
  rows.forEach((row) => {
    var _a;
    const key = keyOf(row.group, columns);
    rowsByKey.set(key, [...(_a = rowsByKey.get(key)) != null ? _a : [], row]);
  });
  return rowsByKey;
};
export const sum = (rows, valueOf) => rows.reduce((total, row) => total + valueOf(row), 0);
export const toBreakdownRows = (rows, grouping) => {
  const { columns, list } = GROUPINGS[grouping];
  const breakdownRows = [...groupByKey(rows, columns)].map(([key, usageRows]) => ({
    key,
    group: groupOf(usageRows[0].group, columns),
    listValues: list ? distinctValues(usageRows, list.dimension) : [],
    runs: sum(usageRows, (row) => row.runs),
    runsFailed: sum(usageRows, (row) => row.runs_failed),
    inputTokens: sum(usageRows, (row) => row.tokens.input_tokens),
    outputTokens: sum(usageRows, (row) => row.tokens.output_tokens),
    totalTokens: sum(usageRows, (row) => row.tokens.total_tokens)
  }));
  return breakdownRows.sort((a, b) => b.totalTokens - a.totalTokens);
};
